import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerService } from '../../../services/customer.service';
import { LocalizationService } from 'shared/src/public-api';


@Component({
  selector: 'select-group',
  templateUrl: './select-group.component.html',
  styleUrls: ['./select-group.component.scss']
})
export class SelectGroupComponent implements OnInit {

  companyGroups: any[] = new Array();
  constructor(private customerService: CustomerService, private _localizationService: LocalizationService) { }

  ngOnInit(): void {
    this.loadGroups();
  }

  private loadGroups() {
    this.customerService.getAllCompanyGroups().subscribe((res: any) => {
      this.companyGroups = res.entities.map((name, index) => ({ id: index, name }));
  
      if (this._selectedGroup && this.companyGroups.find(g => g.name === this._selectedGroup)) {
        this.selectedGroupChange.emit(this._selectedGroup);
      }
    });
  }
  private _selectedGroup: string;
  @Input() set selectedGroup(data: string) {
    if (data !== this.selectedGroup) {
        this._selectedGroup = data;       
      this.selectedGroupChange.emit(data);
    }
  }
  get selectedGroup() { return this._selectedGroup }




  @Output() selectedGroupChange: EventEmitter<any> = new EventEmitter<any>();

}
